<template>
	<div class="header-bottombar">
		<header class="header">
			<h1>{{title}}</h1>
			<i @click="back" class="cubeic-back">
				<van-icon size='20px' name="arrow-left" />
			</i>
			<i class="cubeic-right">
				<slot name="hright"></slot>
			</i>
		</header>
		<div class="wrapper">
			<main class="content">
				<slot name="content">{{content}}</slot>
			</main>
		</div>
		<van-tabbar v-model="activeTabbar" @change="onTabbarChange" active-color="#f19f72"
			:style="'background-color:'+gcfg.BackgroundColor">
			<van-tabbar-item>
				<!--
				<div>我的小店</div>
				<template #icon="props">
					<van-icon :name="props.active ? 'shop':'shop-o'" />
				</template> -->
				<div class="wxcontainer">
					<div class="wxcontent">
						<div class="nrr">
							<van-icon :name="'shop'" />
							<div>我的小店</div>
						</div>
					</div>
					<wx-open-launch-weapp :username="username" :path="'pages/MyShop/shop?store_id='+this.$store.getters.getShop"
						style="width: 100%;height: 100%;position: absolute;
							top: 0;left: 0;">
						<script type="text/wxtag-template">
							<style>
								.btn{
									position: absolute;
									top: 0;
									left: 0;
									width: 100%;
									height: 100%;
									opacity: 0;
								}
								</style>
							<button class="btn">打开小程序</button>
					</script>
					</wx-open-launch-weapp>
				</div>
			</van-tabbar-item>
			<van-tabbar-item><span>选品上架</span>
				<template #icon="props">
					<van-icon :name="props.active ? 'goods-collect':'goods-collect-o'" />
				</template>
			</van-tabbar-item>
			<van-tabbar-item><span>店铺中心</span>
				<template #icon="props">
					<van-icon :name="props.active ? 'shop-collect':'shop-collect-o'" />
				</template>
			</van-tabbar-item>
		</van-tabbar>
	</div>
</template>

<script>
	import * as util from '@/utils/network'
	export default {
		props: {
			title: {
				type: String,
				default: '',
				required: true
			},
			desc: {
				type: String,
				default: ''
			},
			content: {
				type: String,
				default: ''
			},
			curactive: {
				type: String,
				default: 'setting'
			},
			bgcolor: {
				type: String,
				default: ''
			}
		},
		data() {
			return {
				active: this.curactive,
				gcfg: [],
				activeTabbar: 0,
				username: ''
			};
		},
		mounted() {
			this.getConfig()
		},
		methods: {
			getConfig() {
				let that = this
				var href = window.location.href
				if (window.__wxjs_is_wkwebview) {
					var href = window.location.href
					if (window.entryUrl == '' || window.entryUrl == undefined) {
						window.entryUrl = window.location.href.split('#')[0]
					}
					href = window.entryUrl
				}
				var url = "/addons/litestore/api.index/getJsSdkConfig"

				let param = {
					url: href,
					store_id: that.$store.getters.getShop
				}
				util.post(url, param, function(result) {
					console.log(result)
					//初始配置
					var config = result.data.config;
					that.username = config.username

					wx.config({
						debug: config.debug, // 调试时可开启
						appId: config.appId, // <!-- replace -->
						timestamp: data.timestamp, // 生成签名的时间戳，必填，填任意数字即可
						nonceStr: data.nonceStr, // 生成签名的加密字符串，必填，填任意非空字符串即可
						signature: data.signature, // 生成的签名，必填，填任意非空字符串即可
						jsApiList: ["chooseImage", "previewImage",
							"wx-open-launch-weapp"
						], // 必填，随意一个接口即可（跳转小程序的任意接口即可）
						openTagList: ["wx-open-launch-weapp"], // 填入打开小程序的开放标签名
					});
					/* eslint-disable */
					wx.ready(function() {
						console.log('ready')
					});
				});
			},
			onTabbarChange(index) {
				this.setActiveTabbar()
				switch (index) {
					case 0:
						// util.redirect('myshop')
						this.$router.push({
							name: 'shopshare'
						})
						break
					case 1:
						this.$router.push({
							name: 'XpSj'
						})
						break
					case 2:
						this.$router.push({
							name: 'ShopSetting'
						})
						break
					default:
				}
			},
			setActiveTabbar() {
				let that = this
				switch (that.$route.name) {
					case 'MyShop':
						that.activeTabbar = 0
						break
					case 'XpSj':
						that.activeTabbar = 1
						break
					case 'ShopSetting':
						that.activeTabbar = 2
						break
					default:
				}
			},
			back() {
				this.$router.push('/my')
			},
		},
		created() {
			this.setActiveTabbar()
			this.gcfg = this.$store.getters.getGcfg
		},
		watch: {
			"$store.state.gcfg"() {
				this.gcfg = this.$store.getters.getGcfg
			}
		},
	}
</script>

<style scoped lang="less">
	h1 {
		margin: 0
	}

	.wxcontainer {
		position: relative;
		height: 50px;
	}

	.btn {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		opacity: 0;
	}

	.wxcontent {
		width: 100%;
		height: 100%;
		background-repeat: no-repeat;
		background-position: center center;
		background-size: 100% 100%;

		.nrr {
			min-width: 100px;
			height: 50px;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;

			.van-icon {
				padding-bottom: 5px;
				font-size: 22px;
			}
		}
	}
</style>


<style lang="less" scoped="scoped">
	.van-tabbar-item--active {
		// color: #f0aa9b !important;
		// font-weight: 200 !important;
		background-color: transparent;

		.van-tabbar-item {
			color: #c1c1c1;
		}
	}

	.header-bottombar {
		position: absolute;
		z-index: 10;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: #fafafa;

		.header {
			position: relative;
			height: 44px;
			line-height: 44px;
			text-align: center;
			background-color: #edf0f4;
			box-shadow: 0 1px 6px #ccc;
			-webkit-backface-visibility: hidden;
			backface-visibility: hidden;
			z-index: 5;

			h1 {
				font-size: 16px;
				font-weight: 700;
			}

			.cubeic-back {
				position: absolute;
				top: 0;
				left: 0;
				padding: 5px 15px;
				color: #6d189e;
			}

			.cubeic-right {
				position: absolute;
				top: 0;
				right: 0;
				padding: 5px 15px;
				color: #6d189e;
			}
		}

		>.wrapper {
			height: calc(100% - 44px);
			overflow-x: hidden;
			overflow-y: auto;

			.content {
				padding-bottom: 50px;
			}
		}
	}
</style>
